var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sign } from "../shared/signer";
import { SigningKey } from "../shared/@types/sign";
import { V4WrappedDocument } from "./types";
export const signDocument = (document, algorithm, keyOrSigner) => __awaiter(void 0, void 0, void 0, function* () {
    const parsedResults = V4WrappedDocument.pick({ proof: true }).passthrough().safeParse(document);
    if (!parsedResults.success) {
        throw new WrappedDocumentValidationError(parsedResults.error);
    }
    if (!SigningKey.guard(keyOrSigner) && keyOrSigner.signMessage === undefined) {
        throw new Error(`Either a keypair or ethers.js Signer must be provided`);
    }
    const { proof: validatedProof } = parsedResults.data;
    const merkleRoot = `0x${validatedProof.merkleRoot}`;
    try {
        const signature = yield sign(algorithm, merkleRoot, keyOrSigner);
        const proof = Object.assign(Object.assign({}, validatedProof), { key: "public" in keyOrSigner ? keyOrSigner.public : `did:ethr:${yield keyOrSigner.getAddress()}#controller`, signature });
        return Object.assign(Object.assign({}, document), { proof });
    }
    catch (error) {
        throw new CouldNotSignDocumentError(error);
    }
});
class WrappedDocumentValidationError extends Error {
    constructor(error) {
        super(`Document has not been properly wrapped:\n${JSON.stringify(error.format(), null, 2)}`);
        this.error = error;
        Object.setPrototypeOf(this, WrappedDocumentValidationError.prototype);
    }
}
/**
 * Cases where this can be thrown includes: network error, invalid keys or signer
 */
class CouldNotSignDocumentError extends Error {
    constructor(error) {
        super(`Could not sign document:\n${error instanceof Error ? error.message : JSON.stringify(error, null, 2)}`);
        this.error = error;
        Object.setPrototypeOf(this, CouldNotSignDocumentError.prototype);
    }
}
export const signDocumentErrors = {
    WrappedDocumentValidationError,
    CouldNotSignDocumentError,
};
